<template>
    <div class="brand-location-creator">
        <div
            v-for="(location, index) in internalLocations"
            :key="index"
            class="card mb-3"
        >
            <div class="card-body">
                <div class="row">
                    <div class="col-md-5">
                        <div class="form-group">
                            <label>Şube Adı</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="location.name"
                                placeholder="Örn: Kadıköy Şubesi"
                            />
                        </div>
                    </div>

                    <div class="col-md-7">
                        <div class="form-group">
                            <label>Adres</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="location.address"
                                placeholder="Açık adres"
                            />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Telefon(lar)</label>

                            <div
                                v-for="(phone, pIndex) in location.phones"
                                :key="pIndex"
                                class="d-flex mb-2"
                            >
                                <input
                                    type="text"
                                    class="form-control mr-2"
                                    v-model="location.phones[pIndex]"
                                    placeholder="+90 5xx xxx xx xx"
                                />

                                <button
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    @click="removePhone(index, pIndex)"
                                    v-if="location.phones.length > 1"
                                >
                                    ×
                                </button>
                            </div>

                            <button
                                type="button"
                                class="btn btn-sm btn-outline-secondary"
                                @click="addPhone(index)"
                            >
                                + Telefon Ekle
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                        <label>Enlem (latitude)</label>
                        <input
                            type="number"
                            step="any"
                            v-model="location.location.coordinates[1]"
                            class="form-control"
                        />
                    </div>

                    <div class="col-md-3">
                        <label>Boylam (longitude)</label>
                        <input
                            type="number"
                            step="any"
                            v-model="location.location.coordinates[0]"
                            class="form-control"
                        />
                    </div>

                    <div class="col-md-3 d-flex align-items-center">
                        <div class="togglebutton">
                            <label>
                                <input
                                    type="checkbox"
                                    v-model="location.isActive"
                                />
                                <span class="toggle"></span>
                                Aktif
                            </label>
                        </div>
                    </div>

                    <div class="d-flex flex-row" style="gap:10px;">
                        <!-- If id exist, record exist in db, you can update-->
                        <button
                            v-if="location.id"
                            type="button"
                            class="btn btn-primary btn-sm"
                            @click="updateLocation(index)"
                        >
                            Güncelle
                        </button>

                        <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            @click="removeLocation(index)"
                        >
                            Şubeyi Sil
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <button
            type="button"
            class="btn btn-outline-primary"
            @click="addLocation"
        >
            + Yeni Şube Ekle
        </button>

        <input type="hidden" name="locations" :value="serializedLocations" />
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "brand-location-creator",

    props: {
        locations: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            internalLocations: []
        };
    },

    mounted() {
        if (this.locations.length) {
            this.internalLocations = this.locations.map(l => ({
                id: l.id || l._id || null,
                name: l.name || "",
                phones: l.phones && l.phones.length ? l.phones : [""],
                address: l.address || "",
                location: {
                    type: "Point",
                    coordinates: [
                        l.location.coordinates[0], // [lng]
                        l.location.coordinates[1] //[ltd]
                    ]
                },
                isActive: l.isActive !== undefined ? l.isActive : true
            }));
        } else {
            this.addLocation();
        }
    },

    computed: {
        serializedLocations() {
            return JSON.stringify(this.internalLocations);
        }
    },

    methods: {
        addLocation() {
            this.internalLocations.push({
                name: "",
                phones: [""],
                address: "",
                location: {
                    type: "Point",
                    coordinates: [null, null] // [lng, lat]
                },
                isActive: true
            });
        },

        addPhone(locationIndex) {
            this.internalLocations[locationIndex].phones.push("");
        },

        removePhone(locationIndex, phoneIndex) {
            this.internalLocations[locationIndex].phones.splice(phoneIndex, 1);
        },

        async removeLocation(index) {
            if (this.internalLocations.length === 1) {
                alert("En az bir şube olması gerekli");
                return;
            }

            var result = confirm(
                "Bu işlem geri alınamaz. Silmek istediğinize emin misiniz? "
            );
            if (result) {
                await axios.delete(
                    `deleteBrandLocation/${this.internalLocations[index].id}`
                );

                this.internalLocations.splice(index, 1);
            }
        },

        async updateLocation(locationIndex) {
            // shallow copy data
            const data = JSON.parse(
                JSON.stringify(this.internalLocations[locationIndex])
            );

            // fix str to number for locations
            data.location.coordinates[0] = new Number(
                data.location.coordinates[0]
            );

            data.location.coordinates[1] = new Number(
                data.location.coordinates[1]
            );

            // send data
            await axios.post(`updateBrandLocation`, data);
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/vue/brand-location-creator.vue